import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import UserModel from "../models/UserModel";
import CommentModel from "../models/CommentModel";
import Modifiers from "../models/Modifiers";

export default class FormHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "init":
                return this.handleInit(model, params);
            case "form/value":
                return this.handleValue(model, params);
            case "form/submit":
                return this.handleSubmit(model, params);
            case "form/result":
                return this.handleResult(model, params);
            case "form/error":
                return this.handleError(model, params);
            default:
                return model;
        }
    }

    private handleInit(model: DiscussionModel, params?: any): DiscussionModel {

        if (sessionStorage) {
            const value = sessionStorage.getItem("discussion/" + model.getDiscussion() + "/form");
            if (value) {
                model = model.setFormValue(value);
            }
        }

        return model;

    }

    private handleResult(model: DiscussionModel, data: any): DiscussionModel {

        if (sessionStorage) {
            sessionStorage.setItem("discussion/" + model.getDiscussion() + "/form", "");
        }

        data.children = false;
        data.user = data.user ? new UserModel(data.user) : null;

        model = Modifiers.setFormSending(model, false);
        model = Modifiers.appendComment(model, new CommentModel(data));
        model = model.setFormValue("");

        if (model.getUser() && !model.getUser().isVerified()) {
            model = model.showModalVerify();
        }

        return model;

    }

    private handleError(model: DiscussionModel, params?: any): DiscussionModel {
        model = Modifiers.setFormSending(model, false);
        this.dispatch("error", 2);
        return model;
    }

    private handleValue(model: DiscussionModel, value: string): DiscussionModel {

        if (sessionStorage) {
            sessionStorage.setItem("discussion/" + model.getDiscussion() + "/form", value);
        }

        return model.setFormValue(value);

    }

    private handleSubmit(model: DiscussionModel, params?: any): DiscussionModel {

        if (model.isFormSending() != true && model.getFormValue() != "") {
            if (model.getUser()) {
                const user = model.getUser();
                if (!model.isPremium() || user.hasPremium() || user.isEditor()) {
                    model = Modifiers.setFormSending(model, true);
                    this.fetch("create", {
                        project: model.getProject(),
                        discussion: model.getDiscussion(),
                        content: model.getFormValue(),
                    }).then((response) => {
                        if (response.result) {
                            this.dispatch("form/result", response.result);
                        } else {
                            this.dispatch("form/error");
                        }
                    }).catch((error) => {
                        this.dispatch("form/error");
                    });
                } else {
                    this.dispatch("premium");
                }
            } else {
                this.dispatch("login", 1);
            }
        } else {

        }

        return model;

    }

}